import React from "react";
import { Box } from "@mui/material";
import "../PageLoader/PageLoader.css";
import "./RELoader.css";

interface RELoaderProps {
  minHeight?: number | string;
}

const RELoader: React.FC<RELoaderProps> = ({ minHeight = 200 }) => {
  return (
    <Box
      className="re-inline-loader"
      sx={{ minHeight }}
      role="status"
      aria-label="Loading"
    >
      <div className="re-page-loader-inner">
        <div className="fadein-element">
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-01.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-02.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-03.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-04.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-05.svg"
          />
        </div>
        <div className="loading-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </Box>
  );
};

export default RELoader;
